import { z } from "zod";
export const BancoNotificacionSchema = z.enum([
    "NEQUI",
    "BANCOLOMBIA",
    "DAVIPLATA",
    "OTRO",
]);
export const EstadoPagoBancarioSchema = z.enum([
    "PENDIENTE",
    "ASOCIADO",
    "CONFIRMADO",
    "IGNORADO",
]);
/** Webhook de entrada cuando llega un correo de banco (vía Sendgrid, Make, Zapier, Inbound Webhook o script) */
export const WebhookCorreoSchema = z.object({
    sucursalId: z.string().uuid().optional(),
    remitenteEmail: z.string().optional(),
    from_email: z.string().optional(),
    from: z.string().optional(),
    sender: z.string().optional(),
    asunto: z.string().optional(),
    subject: z.string().optional(),
    cuerpo: z.string().optional(),
    body_plain: z.string().optional(),
    body: z.string().optional(),
    fecha: z.string().optional(),
});
/** Entrada manual o directa de transferencia bancaria */
export const CrearPagoBancarioInputSchema = z.object({
    sucursalId: z.string().uuid(),
    banco: BancoNotificacionSchema.default("OTRO"),
    monto: z.number().positive("El monto debe ser mayor a 0"),
    remitente: z.string().optional(),
    referencia: z.string().optional(),
    emailOrigen: z.string().optional(),
    asuntoCorreo: z.string().optional(),
    cuerpoCorreo: z.string().optional(),
    recibidoEn: z.string().datetime().optional(),
});
export const AsociarPagoBancarioSchema = z.object({
    facturaId: z.string().uuid("ID de factura inválido"),
});
export const FiltroPagosBancariosQuerySchema = z.object({
    estado: EstadoPagoBancarioSchema.optional(),
    banco: BancoNotificacionSchema.optional(),
    limite: z.coerce.number().int().min(1).max(100).default(20),
    desde: z.string().optional(),
});
/** Lo que REALMENTE devuelve GET /pagos-bancarios (monto llega como string, Decimal de Prisma). */
export const PagoBancarioRespuestaSchema = z.object({
    id: z.string(),
    sucursalId: z.string(),
    banco: BancoNotificacionSchema,
    monto: z.coerce.number(),
    remitente: z.string().nullable(),
    referencia: z.string().nullable(),
    emailOrigen: z.string().nullable(),
    asuntoCorreo: z.string().nullable(),
    cuerpoCorreo: z.string().nullable(),
    estado: EstadoPagoBancarioSchema,
    recibidoEn: z.string(),
    facturaId: z.string().nullable(),
    asociadoPorId: z.string().nullable(),
    factura: z
        .object({
        id: z.string(),
        total: z.coerce.number(),
        clienteNombre: z.string().nullable(),
        creadoEn: z.string(),
    })
        .nullable()
        .optional(),
    asociadoPor: z.object({ id: z.string(), nombre: z.string() }).nullable().optional(),
});
//# sourceMappingURL=pagos-bancarios.schema.js.map